var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79297 1.26953L6.04297 5.01953L9.76172 8.73828C10.0742 9.01953 10.0742 9.48828 9.76172 9.76953C9.48047 10.082 9.01172 10.082 8.73047 9.76953L4.98047 6.05078L1.26172 9.76953C0.980469 10.082 0.511719 10.082 0.230469 9.76953C-0.0820312 9.48828 -0.0820312 9.01953 0.230469 8.70703L3.94922 4.98828L0.230469 1.26953C-0.0820312 0.988281 -0.0820312 0.519531 0.230469 0.207031C0.511719 -0.0742188 0.980469 -0.0742188 1.29297 0.207031L5.01172 3.95703L8.73047 0.238281C9.01172 -0.0742188 9.48047 -0.0742188 9.79297 0.238281C10.0742 0.519531 10.0742 0.988281 9.79297 1.26953Z",
    fill: "#CB3D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.b7dec618eb082808a8e5b454fcfafacb.svg";
export { ForwardRef as ReactComponent };